import React from "react";

export const PageHeader = ({ title, kicker, children }) => (
  <div className="border-b hairline px-6 py-5 flex items-end justify-between bg-[#15151F] sticky top-0 z-10">
    <div>
      {kicker && <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan-300 mb-1">{kicker}</div>}
      <h1 className="font-display text-2xl font-extrabold tracking-tight">{title}</h1>
    </div>
    <div className="flex items-center gap-2">{children}</div>
  </div>
);

export const SevBadge = ({ sev, children }) => (
  <span data-testid={`sev-${sev}`} className={`sev-${sev} px-2 py-0.5 text-[10px] font-mono uppercase tracking-widest rounded-sm inline-flex items-center gap-1`}>
    {children || sev}
  </span>
);

export const Panel = ({ title, kicker, right, children, className = "" }) => (
  <section className={`panel ${className}`}>
    {(title || right) && (
      <div className="flex items-center justify-between px-4 py-3 border-b hairline">
        <div>
          {kicker && <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{kicker}</div>}
          {title && <div className="font-display text-sm font-bold tracking-tight">{title}</div>}
        </div>
        <div>{right}</div>
      </div>
    )}
    <div>{children}</div>
  </section>
);

export const Stat = ({ label, value, sub, tone = "default" }) => {
  const toneCls = {
    default: "text-white",
    ai: "text-cyan-300",
    critical: "text-red-400",
    high: "text-orange-400",
    ok: "text-emerald-400",
  }[tone] || "text-white";
  return (
    <div className="panel p-4">
      <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{label}</div>
      <div className={`font-display text-3xl font-extrabold tracking-tight mt-2 ${toneCls}`}>{value}</div>
      {sub && <div className="text-[11px] text-zinc-500 mt-1">{sub}</div>}
    </div>
  );
};

export const Empty = ({ msg = "No data" }) => (
  <div className="p-8 text-center text-zinc-500 font-mono text-xs uppercase tracking-widest">{msg}</div>
);
